import { Form, Modal, ModalProps } from 'antd';
import SubgroupForm from '../../SubgroupForm';
import { useCreateSubGroup } from '@/core/domain/operational/SubGroups/SubGroups.hooks';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  groupId?: number;
  onCallback: (subGroupId: number) => void;
}

export default function CreateSubGroupModal({
  groupId,
  onCallback,
  ...props
}: Props) {
  const [form] = Form.useForm();

  const createSubGroup = useCreateSubGroup();

  async function handleOk() {
    const values = await form.validateFields();

    const obj = {
      ...values,
      groupId,
    };

    const response = await createSubGroup.mutateAsync(obj);

    handleCancel();

    onCallback(response.id);
  }

  function handleCancel() {
    props.onCancel();
  }

  return (
    <Modal
      {...props}
      title="Criação de sub-grupo"
      onOk={handleOk}
      confirmLoading={createSubGroup.isLoading}
      onCancel={handleCancel}
    >
      <SubgroupForm form={form} />
    </Modal>
  );
}
